module.exports = __webpack_public_path__ + "static/media/splash.10c8362e.png";